import React, { useState } from "react";

const RoleExtractor = ({ onConfirm }) => {
  const [roleText, setRoleText] = useState("");

  const handleConfirm = () => {
    if (!roleText.trim()) {
      alert("Please enter or paste a job description or role.");
      return;
    }
    onConfirm(roleText.trim());
  };

  return (
    <div className="bg-white p-6 rounded-xl shadow-xl text-center space-y-4">
      <h2 className="text-2xl font-bold text-indigo-700">
        📝 Enter Job Role or Paste JD
      </h2>

      <textarea
        className="w-full border p-3 rounded-md min-h-[120px]"
        placeholder="e.g. React Developer with 3+ years of experience..."
        value={roleText}
        onChange={(e) => setRoleText(e.target.value)}
      />

      <button
        onClick={handleConfirm}
        className="bg-violet-600 hover:bg-violet-700 text-white px-6 py-2 rounded-xl transition duration-200"
      >
        Confirm Role
      </button>
    </div>
  );
};

export default RoleExtractor;
